function pricing() {
	const $pricingSection = $('section.pricing');
	if (!$pricingSection.length) return;

	$pricingSection.on('click', '.payments-type a', function(e) {
		e.preventDefault();

		const $clickedLink = $(this);
		const targetTabId = $clickedLink.data('payment-tab');

		const $parentPackage = $clickedLink.closest('.package');

		const $packageLinks = $parentPackage.find('.payments-type a');
		const $packageContents = $parentPackage.find('.payment-content');

		$packageLinks.removeClass('active');
		$packageContents.removeClass('active');

		$clickedLink.addClass('active');

		$packageContents.filter(`[data-payment-content="${targetTabId}"]`).addClass('active');
	});
}
